import React, { useState } from "react";
import styled from "styled-components";
import Swal from "sweetalert2";
import { SVGs } from "../../assets/svg/SVGs";
import ProfileType from "./E-ProfileType";
import imageCompression from "browser-image-compression";

const EditSOS = ({ emergencyData, onFinish }) => {
  const [loading, setLoading] = useState(false);
  const [localImage, setLocalImage] = useState(null);
  const [imageToUse, setImageToUse] = useState(null);
  const [inputValue, setInputValue] = useState({
    title: emergencyData?.title,
    business_name: emergencyData?.business_name,
    description: emergencyData?.description,
    phone_number: emergencyData?.phone_number,
    url: emergencyData?.url,
    to_date: emergencyData?.to_date,
    from_date: emergencyData?.from_date,
    placement_of_banner: emergencyData?.placement_of_banner || [],
    subscription_type: emergencyData?.subscription_type || "BASIC",
    subcategory_marketplace:
      emergencyData?.subcategory_marketplace || "AC_REPAIR",
  });

  const [acceptable, setAcceptable] = useState(null);

  const [compressing, setCompressing] = useState(false);

  const MAX_SIZE_MB = 1; // 2 MB

  const encodeFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleImage = async (file) => {
    if (!file) return;
    const fileSizeMB = file.size / 1024 / 1024; // convert bytes → MB
    let compressedFile = file;

    if (fileSizeMB > MAX_SIZE_MB) {
      setCompressing(true);
      try {
        const options = {
          maxSizeMB: MAX_SIZE_MB,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
          initialQuality: 0.8,
        };
        const compressedBlob = await imageCompression(file, options);

        compressedFile = new File([compressedBlob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
      } catch (err) {
        console.error("Compression error:", err);
      } finally {
        setCompressing(false);
      }
    }

    encodeFileToBase64(compressedFile).then((res) => {
      setLocalImage(
        Object.assign({ image: res }, compressedFile, {
          preview: URL.createObjectURL(compressedFile),
        })
      );
    });
    return setImageToUse(compressedFile);
  };

  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    const imageRatio = +(naturalWidth / naturalHeight).toFixed(2); // keep 2 decimals
    const ratio = imageRatio;

    // if (ratio >= 2.23 && ratio <= 2.43) {
    setAcceptable(true);
    // } else {
    //   setAcceptable(false);
    // }
  };

  const handleSubmit = (event) => {
    // if (!acceptable) {
    //   return alert(
    //     "Image dimension not accepted, the banner should be of ration 21:9"
    //   );
    // }

    const objectToArray = Object.entries(inputValue);
    const formData = new FormData();
    if (imageToUse) formData.append("image", imageToUse);

    objectToArray.forEach((entries) => {
      formData.append(entries[0], entries[1]);
    });

    event.preventDefault();
    onFinish(emergencyData.id, formData);
  };

  return (
    <form
      onSubmit={handleSubmit}
      // method="post"
      // action="/profile"
      className="new_estates_form fade-in-bck"
    >
      <div className="form-group">
        {/* <label htmlFor="title">Email address</label> */}

        <div className="create_est ">
          <div className="form_txt">
            <div className="capture_close">
              <h4>Edit</h4>
            </div>
          </div>

          <div className="inputplabel">
            <input
              type="file"
              id="imageChanger"
              onChange={(e) => handleImage(e.target.files[0])}
              accept="image/png, image/gif, image/jpeg"
            />
          </div>

          {compressing ? (
            <p>Loading...</p>
          ) : (
            <>
              {localImage && (
                <div
                  style={{
                    width: "100%",
                    marginRight: "auto",
                    marginLeft: "auto",
                  }}
                >
                  <img
                    style={{
                      width: "auto",
                      height: "200px",
                      position: "relative",
                      right: 0,
                      top: 0,
                      bottom: 0,
                    }}
                    src={localImage.image}
                    alt="banner"
                    onLoad={handleImageLoad}
                  />
                </div>
              )}
            </>
          )}

          {/* Create Account Type */}
          <input
            value={inputValue.title}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                title: e.target.value,
              }))
            }
            type="text"
            id="title"
            name="title"
            placeholder="Advert Title"
          />

          <input
            value={inputValue.business_name}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                business_name: e.target.value,
              }))
            }
            type="text"
            id="business_name"
            name="business_name"
            placeholder="Business Name"
          />

          <div
            style={{
              marginBottom: "20px",
              marginTop: "10px",
            }}
          >
            <p>Select Subscription Package</p>
            <select
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                padding: "15px",
                fontSize: "16px",
                lineHeight: "1.4",
                color: "var(--Gunmetal)",
                backgroundColor: "#fff",
                border: "1px solid #dfe3e7",
                borderRadius: "5px",
                transition:
                  "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                marginBottom: "15px",
              }}
              value={inputValue.subscription_type}
              onChange={(e) =>
                setInputValue((initValues) => ({
                  ...initValues,
                  subscription_type: e.target.value,
                }))
              }
              type="text"
              id="subscription_type"
              name="subscription_type"
              placeholder="Subscription Type"
            >
              <option id={"BASIC"} value={"BASIC"}>
                BASIC (Marketplace)
              </option>
              <option id={"SILVER"} value={"SILVER"}>
                SILVER (Access Code)
              </option>
              <option id={"GOLD"} value={"GOLD"}>
                GOLD (Homepage and Access Code)
              </option>
              <option id={"PLATIUM"} value={"PLATIUM"}>
                PLATINUM (All Sections)
              </option>
            </select>
          </div>

          {(inputValue.subscription_type === "BASIC" ||
            inputValue.subscription_type === "PLATIUM") && (
            <div
              style={{
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              <p>Select Marketplace Sub-section</p>
              <select
                style={{
                  display: "block",
                  width: "100%",
                  height: "auto",
                  padding: "15px",
                  fontSize: "16px",
                  lineHeight: "1.4",
                  color: "var(--Gunmetal)",
                  backgroundColor: "#fff",
                  border: "1px solid #dfe3e7",
                  borderRadius: "5px",
                  transition:
                    "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                  marginBottom: "15px",
                }}
                value={inputValue.subcategory_marketplace}
                onChange={(e) =>
                  setInputValue((initValues) => ({
                    ...initValues,
                    subcategory_marketplace: e.target.value,
                  }))
                }
                type="text"
                id="subcategory_marketplace"
                name="subcategory_marketplace"
                placeholder="Subscription Type"
              >
                {[
                  "AC_REPAIR",
                  "CHEF",
                  "CLEANING",
                  "GARDENER",
                  "PLUMBER",
                  "SECURITY",
                  "ELECTRICIAN",
                  "FUMIGATION",
                  "CARPENTER",
                  "PAINTER",
                  "TAILOR",
                  "MECHANIC",
                  "PHOTOGRAPH",
                  "BARBER",
                  "GROCERIES_SHOPPING",
                  "HEALTH_AND_WELLNESS",
                  "REAL_ESTATE",
                  "FASHION_AND_LIFESTYLE",
                  "AUTOMOBILE",
                  "DELIVERY",
                ].map((parketpl) => (
                  <option value={parketpl}>{parketpl}</option>
                ))}
              </select>
            </div>
          )}

          <input
            value={inputValue.description}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                description: e.target.value,
              }))
            }
            type="text"
            id="title"
            name="title"
            placeholder="Business Description"
          />
          <input
            value={inputValue.phone_number}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                phone_number: e.target.value,
              }))
            }
            type="number"
            id="phone"
            name="phone"
            placeholder="Phone Number"
          />
          <input
            value={inputValue.url}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                url: e.target.value,
              }))
            }
            id="url"
            name="url"
            placeholder="Url link"
          />
        </div>
        <button type="submit">Edit Advert</button>
      </div>
    </form>
  );
};

const Modal = ({ open, onClose, emergencyData, onFinish }) => {
  if (!open) return null;
  return (
    <ModalWrapper onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <EditSOS emergencyData={emergencyData} onFinish={onFinish} />
        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </ModalWrapper>
  );
};
export default Modal;

let ModalWrapper = styled.div`
  .modalContainer {
    max-width: 600px;
    .new_estates_form {
      max-width: 600px;
    }
  }
  .create_est {
    h4 {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
    }
  }
`;

let RevokeAccess = styled.div`
  .revokeOnes {
    height: 200px;
    overflow: auto;
  }
  h2 {
    font-size: 20px;

    font-weight: bold;
    margin-bottom: 0px;
  }
  .cntr {
    margin-top: 10px;
  }
`;
